export const ActionMasterIcon = () => {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6 7.1999L16 1.9999C15.8 1.8999 15.6 1.8999 15.4 1.8999H3.1C2.9 1.8999 2.7 1.8999 2.5 1.9999L7.9 7.1999C8.7 7.8999 9.9 7.8999 10.6 7.1999Z"
        fill="#0056B8"
      />
      <path
        d="M9.9 13.6C9.9 10.7 12.2 8.4 15.1 8.4C15.9 8.4 16.7 8.6 17.4 9V4C17.6 3.4 17.3 2.9 16.9 2.5L10.6 8.5C9.9 9.2 8.7 9.2 7.9 8.5L1.6 2.5C1.2 2.9 1 3.4 1 4V12.6C1 13.7 1.9 14.6 3 14.6H10C9.9 14.3 9.9 13.9 9.9 13.6Z"
        fill="#0056B8"
      />
      <path
        d="M15.0998 9.30005C12.6998 9.30005 10.7998 11.2 10.7998 13.6C10.7998 16 12.6998 17.9 15.0998 17.9C17.4998 17.9 19.3998 16 19.3998 13.6C19.3998 11.2 17.4998 9.30005 15.0998 9.30005ZM16.3998 14.9C16.2998 15 16.0998 15 15.8998 14.9L14.7998 13.8C14.6998 13.7 14.6998 13.7 14.6998 13.6V11.9C14.6998 11.7 14.7998 11.6 14.9998 11.6C15.1998 11.6 15.2998 11.7 15.2998 11.9V13.5L16.2998 14.5C16.4998 14.6 16.4998 14.8 16.3998 14.9Z"
        fill="#0056B8"
      />
    </svg>
  );
};
